import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  RECAPTCHA_SETTINGS,
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
} from 'ng-recaptcha';
import { NgxStripeModule } from 'ngx-stripe';
import { AuthService } from 'src/app/services/auth.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { environment } from 'src/environments/environment';
import { AuthorizationRoutingModule } from './authorization-routing.module';
import { ForgetResetEmailComponent } from './forget-reset-email/forget-reset-email.component';
import { LoginComponent } from './login/login.component';
import { CompanyDetailFormComponent } from './register/company-detail-form/company-detail-form.component';
import { PaymentFormComponent } from './register/payment-form/payment-form.component';
import { PlanSelectionFormComponent } from './register/plan-selection-form/plan-selection-form.component';
import { RegisterComponent } from './register/register.component';

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    CompanyDetailFormComponent,
    PlanSelectionFormComponent,
    PaymentFormComponent,
    ForgetResetEmailComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AuthorizationRoutingModule,
    SharedModule,
    RecaptchaModule,
    RecaptchaFormsModule, // For forms support
    NgxStripeModule.forRoot(environment.stripeKey),
  ],
  exports: [LoginComponent, RegisterComponent],
  providers: [
    AuthService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptchaSiteKey,
      } as RecaptchaSettings,
    },
  ],
})
export class AuthorizationModule {}
